import React, { useState, useEffect } from "react";
import { Button } from "antd";
import { isFunction } from "lodash";
import { drawerLoading$ } from "../../../library/drawerLoadingService";
import { closeDrawer } from "../../../library/helpers";

const AntdDrawerFooter = ({
  onSave,
  onCancel = () => {},
  onDelete = () => {},
  showDelete = false,
  showSave = true,
  saveText = "Save",
  cancelText = "Cancel",
  deleteText = "Delete",
  showCancel = true,
  loading = false, // External loading prop
  saveDisabled = false, // Guard the primary action until it can be used
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [externalLoading, setExternalLoading] = useState(false);

  const localCancel = () => {
    if (isFunction(onCancel)) {
      onCancel();
      return;
    }

    closeDrawer();
  };

  // Subscribe to drawer loading state from RxJS Subject
  useEffect(() => {
    const subscription = drawerLoading$.subscribe(loadingState => {
      setExternalLoading(loadingState);
    });

    return () => subscription.unsubscribe();
  }, []);

  // Use external loading state if available, otherwise use internal state
  const currentLoading = loading || externalLoading || isLoading;

  const handleSave = async () => {
    try {
      setIsLoading(true);
      if (isFunction(onSave)) {
        await onSave();
      }
    } catch (error) {
      // Handle error if needed
      console.error("Error in onSave:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="w-full flex justify-start gap-3">
      {showSave && (
        <Button
          type="primary"
          onClick={handleSave}
          loading={currentLoading}
          disabled={saveDisabled}
        >
          {saveText}
        </Button>
      )}
      {showCancel && <Button onClick={localCancel}>{cancelText}</Button>}
      {showDelete && (
        <Button danger onClick={onDelete}>
          {deleteText}
        </Button>
      )}
    </div>
  );
};

export default AntdDrawerFooter;
